import React from 'react';
import ReactSlider from 'react-slider';
import styles from './SliderInput.scss';
import InputField from 'ub/ui/inline-text/input-field';
import classNames from 'classnames';

const FALLBACK_VALUE = 0;

export default class SliderInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: props.value || FALLBACK_VALUE,
    };

    this.handleSliderChange = this.handleSliderChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentWillReceiveProps({ value }) {
    this.setState({ value });
  }

  handleSliderChange(value = FALLBACK_VALUE) {
    this.setState({ value });
    this.props.onChange(value);
  }

  handleInputChange(ev) {
    let value = parseInt(ev.target.value, 10);

    if (isNaN(value)) {
      value = this.state.value;
    } else if (value > this.props.max) {
      value = this.props.max;
    } else if (value < this.props.min) {
      value = this.props.min;
    }

    this.setState({ value });
    this.props.onChange(value);
    this.props.onAfterChange(value);
  }

  render() {
    return (
      <div className={classNames('slider-input', styles.container)}>
        <div className={styles.label}>{this.props.label}</div>
        <ReactSlider
          min={this.props.min}
          max={this.props.max}
          step={this.props.step}
          value={this.state.value}
          className={styles.slider}
          handleClassName={styles.knob}
          barClassName={styles.bar}
          withBars
          onChange={this.handleSliderChange}
          onBeforeChange={this.props.onBeforeChange}
          onAfterChange={this.props.onAfterChange}
        />
        <InputField
          inputClassName={styles.sliderInput}
          hideLabel
          valueChangeHandler={this.handleInputChange}
          value={this.state.value}
          readonly={this.props.readonlyInput}
        />
      </div>
    );
  }
}

SliderInput.propTypes = {
  label: React.PropTypes.string,
  max: React.PropTypes.number,
  min: React.PropTypes.number,
  onAfterChange: React.PropTypes.func,
  onBeforeChange: React.PropTypes.func,
  onChange: React.PropTypes.func,
  readonlyInput: React.PropTypes.bool,
  step: React.PropTypes.number,
  value: React.PropTypes.number,
};

SliderInput.defaultProps = {
  label: '',
  max: 100,
  min: 0,
  onAfterChange: () => {},
  onBeforeChange: () => {},
  onChange: () => {},
  readonlyInput: false,
  step: 1,
  value: 1,
};



// WEBPACK FOOTER //
// ./src/components/input/components/SliderInput.jsx